import { BarControlsFeature, BarControlsFeatureKind } from '../controls/bar-controls.feature';
import { BAAS_CONFIRM_SETTINGS } from './baas-confirm.tokens';
import { BaasConfirmSettings } from './baas-confirm.types';

/** Provide global BaaS confirmation settings. */
export function withConfirmSettings(settings: BaasConfirmSettings): BarControlsFeature {
    return {
        kind: BarControlsFeatureKind.ConfirmSettings,
        providers: [
            {
                provide: BAAS_CONFIRM_SETTINGS,
                useValue: settings
            }
        ]
    };
}
